import { render, staticRenderFns } from "./StepperStep.vue?vue&type=template&id=135ca2a1&"
import script from "./StepperStep.vue?vue&type=script&lang=js&"
export * from "./StepperStep.vue?vue&type=script&lang=js&"
import style0 from "./StepperStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepperStep})
